import { useCallback, useMemo, memo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import PropTypes from 'prop-types'

import { ReviewStatus, ReviewStatusDisplayName } from '@tabeeb/enums'
import { usePopoverState } from '@tabeeb/shared/utils/hooks'
import { updateReviewStatusFilter } from '@tabeeb/modules/sessionsPage/actions'
import { getReviewStatusFilter } from '@tabeeb/modules/sessionsPage/selectors/filtration'

import FilterButton from '../FilterButton'
import FilterMenu from '../FilterMenu'
import FilterOptionsSelect from '../FilterOptionsSelect'

const ReviewStatusFilter = ({ variant, ...rest }) => {
  const dispatch = useDispatch()

  const [anchorRef, open, onOpen, onClose] = usePopoverState()

  const initialValues = useSelector(getReviewStatusFilter)

  const options = useMemo(
    () => Object.values(ReviewStatus).map((status) => ({ value: status, name: ReviewStatusDisplayName[status] })),
    []
  )

  const onSubmit = useCallback(
    (values) => {
      dispatch(updateReviewStatusFilter(values))
    },
    [dispatch]
  )

  return (
    <>
      {variant === 'button' && (
        <FilterButton ref={anchorRef} active={initialValues.length !== options.length} onClick={onOpen} {...rest} />
      )}
      {variant === 'select' && (
        <FilterOptionsSelect ref={anchorRef} values={initialValues} options={options} onClick={onOpen} />
      )}
      <FilterMenu
        anchorEl={anchorRef.current}
        open={open}
        onClose={onClose}
        title='Review status'
        initial={initialValues}
        options={options}
        onSubmit={onSubmit}
      />
    </>
  )
}

ReviewStatusFilter.defaultProps = {
  variant: 'button',
}

ReviewStatusFilter.propTypes = {
  variant: PropTypes.oneOf(['button', 'select']),
}

export default memo(ReviewStatusFilter)
